import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { getCountriesWithAbbreviations } from '../../../(recaptcha)/utils/getCountriesWithAbbreviation';

export default function BillingInfoCountryInput({
    initialCountry,
    isEditable,
}: {
    initialCountry: string;
    isEditable?: boolean;
}): JSX.Element {
    // Find the country name for display when not editable
    const countryName = initialCountry
        ? getCountriesWithAbbreviations().find((country) => country.abbreviation === initialCountry)?.name ||
          initialCountry
        : '';

    return (
        <div className="flex flex-row justify-between items-center py-4 border-b-1 border-gray-300">
            <label htmlFor="country" className="w-full">
                Country
            </label>
            {isEditable ? (
                <select
                    id="country"
                    name="country"
                    data-recurly="country"
                    autoComplete="country"
                    defaultValue={initialCountry ?? ''}
                    className={twMerge(
                        'w-full p-2 rounded-sm border border-solid border-white',
                        isEditable && 'border-gray-300 focus:outline-none focus:ring-blue-500',
                        !isEditable && 'appearance-none text-gray-800 font-bold',
                    )}
                >
                    <option value="">Select a Country</option>
                    {getCountriesWithAbbreviations().map((country) => (
                        <option key={country.abbreviation} value={country.abbreviation}>
                            {country.name}
                        </option>
                    ))}
                </select>
            ) : (
                <span className="w-full py-2 text-gray-800 font-bold">{countryName}</span>
            )}
        </div>
    );
}
